import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { MainHeaderComponent } from "../components/shared/main-header/main-header.component";
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-attribute-menu',
  standalone: true,
  imports: [CommonModule, MainHeaderComponent, RouterOutlet],
  templateUrl: './attribute-menu.component.html',
  styleUrl: './attribute-menu.component.scss'
})
export class AttributeMenuComponent {

  formAttribConfig = [
    {id:'1', controlName: 'brand', label: 'Marca', name: 'Marca' },
    {id:'2', controlName: 'category', label: 'Categoría', name: 'Categoria' },
    {id:'3', controlName: 'company', label: 'Compañías', name: 'Compañia' },
    {id:'4', controlName: 'flavor', label: 'Sabor', name: 'Sabor' },
    {id:'5', controlName: 'other', label: 'Otros', name: 'Otros' },
    {id:'6', controlName: 'multi-package', label: 'Multi-empaque', name: 'multiempaque' },
    {id:'7', controlName: 'package', label: 'Paquete', name: 'Paquete' },
    {id:'8', controlName: 'shape', label: 'Forma', name: 'Forma' },
    {id:'9', controlName: 'size', label: 'Tamaños', name: 'Tamaño' },
    {id:'10', controlName: 'presentation', label: 'Presentación', name: 'Compañia' },
    {id:'11', controlName: 'version', label: 'Version', name: 'Versión' },
    {id:'12', controlName: 'line', label: 'Líneas', name: 'Linea' },
    {id:'13', controlName: 'is_competence', label: 'Es comptencia', name: 'Es competencia' },
    {id:'14', controlName: 'family', label: 'Familia', name: 'Familia' }
  ];

  constructor(private router: Router, private route: ActivatedRoute) {
     this.router.navigate(
      ['/library-attributes', { outlets: { table: ['list', 'brand'] } }],
      { queryParams: { label: 'Marca', id: 1} }
    )
    this.selectedAttribute = 'brand'
  }

  selectedAttribute = '';
  selectedId!: number;

  selectAttribute(attr: string) {
    const selected = this.formAttribConfig.find(f => f.controlName === attr);
    if (!selected) return;

    this.selectedAttribute = attr;
    this.selectedId = Number(selected.id);
    this.router.navigate([{ outlets: { table: ['list', attr] } }],
      {
        relativeTo: this.route,
        queryParams: { label: selected.name, id: this.selectedId}
      }
    );
  }


}
